module.exports = __webpack_public_path__ + "img/full3-min.564bb6c3.png";